import Vue from 'vue';
import Buefy from 'buefy';
Vue.use(Buefy, {
    defaultIconPack: 'fas',
    defaultIconComponent: 'font-awesome-icon',
});

export { default as textInput } from './public/textInput.vue';
export { default as chooseInput } from './public/chooseInput.vue';
export { default as fileInput } from './public/fileInput.vue';
export { default as dateInput } from './public/dateInput.vue';
export { default as dateFromNow } from './public/dateFromNow.vue';
export { default as dateRangeFilter } from './public/dateRangeFilter.vue';
export { default as searchChooser } from './public/searchChooser.vue';
export { default as ButtonConfirm } from './public/ButtonConfirm.vue';
export { default as ButtonSave } from './public/ButtonSave.vue';
export { default as UserAvatar } from './public/UserAvatar.vue';
export { default as hasError } from './public/HasError.vue';
export { default as loader } from './public/loader.vue';
export { default as fileUpload } from './public/fileUpload.vue';

export { default as pagination } from './public/pagination.vue';
export { default as paginationMixin } from './mixins/pagination.js';

export { default as defaultLanguageSelect } from './public/defaultLanguageSelect.vue';
export { default as LocaleChanger } from './public/LocaleChanger.vue';

export { default as Sidebar } from './public/Sidebar.vue';
export { default as Sidemenu } from './public/Sidemenu.vue';
export { default as AsideMenu } from './public/AsideMenu.vue';

export { default as aForm } from './components/aForm.vue';
export { default as aFormMixin } from './mixins/aForm.js';

export { default as responsiveIframe } from './public/responsiveIframe.vue';
export { default as fieldsButton } from './public/fieldsButton.vue';
export { default as emptyList } from './public/emptyList.vue';

export { default as collapse } from './public/collapse.vue';

export { default as modal } from './public/modal.vue';
export { default as useModal } from './composables/useModal.js';

export { default as useCurrentProjectChooser } from './composables/useCurrentProjectChooser.js';

export * from './mixins/helpers.js';

export { default as useAppLanguage } from './composables/useAppLanguage.js';

export { default as chooseWorkspaceUser } from './public/chooseWorkspaceUser.vue';
export { default as Icon } from './public/Icon.vue';

export { messageService } from './services/messageService';
